<template>
  <div>
    <md-app md-mode="fixed">
      <md-app-content>
        <slot name="joint-content" />
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
export default {
  name: "JointEventContainer",
  methods: {
    goToLogin() {
      this.$router.push('/welcome')
    }
  }
}
</script>

<style lang="scss">
.md-app {
  height: 100vh;
  &.md-fixed {
    overflow-x: hidden;
  }
}

.menu-items {
  display: flex;
  max-height: 71px;
  img {
    margin: 5px 0px 5px 21px;
  }
  cursor: pointer;
}

.md-app-content {
  height: 90vh;
  padding: 0 !important;
}
</style>
